import type { CalEvent, Template } from '../shared/types';
import { api } from './api';

export const state: { user: string | null; events: CalEvent[]; templates: Template[] } = {
  user: null,
  events: [],
  templates: [],
};

export async function refreshData(): Promise<void> {
  const [events, templates] = await Promise.all([api.events(), api.templates()]);
  state.events = events;
  state.templates = templates;
}

let listener: (() => void) | null = null;
export function onChange(fn: () => void): void {
  listener = fn;
}
export function notifyChange(): void {
  listener?.();
}
